import { getUserInfo } from '@/api/account';
import { initMonitor } from '@/utils/monitor';
const state = {
  init: {},
  userInfo: '',
};

const mutations = {
  CHANGE_USERINFO: (state, data) => {
    if (!data) {
      state.userInfo = '';
      return;
    }
    state.userInfo = { ...data };
    // 拿到 uid 后初始化前端监控（内部已做幂等保护，不会重复初始化）
    if (data.id) {
      initMonitor(data.id);
    }
  },
};

const actions = {
  // 获取用户信息
  async getUserInfo({ commit, state }) {
    const r = await getUserInfo();
    if (!r.code) {
      throw Error();
    }
    commit('CHANGE_USERINFO', r.data);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
